import NamedDto from 'modules/base/dto/NamedDto';
import EdtDynamicCheckVariableEditDto from './EdtDynamicCheckVariableEditDto';

export class EdtDynamicCheckEditDto extends NamedDto {
	constructor() {
		super();

		/** @type {string} */
		this.hostName = null;

		/** @type {string} */
		this.serverName = null;

		/** @type {string} */
		this.modelName = null;

		/** @type {number} */
		this.log = null;

		/** @type {string} */
		this.sequenceStartItemId = null;

		/** @type {number} */
		this.readInterval = null;

		/** @type {number} */
		this.timeWindow = null;

		/** @type {number} */
		this.maxIterations = null;

		/** @type {number} */
		this.minSampleCountForVarianceCheck = null;

		/** @type {EdtDynamicCheckVariableEditDto[]} */
		this.disturbanceVariables = null;

		/** @type {EdtDynamicCheckVariableEditDto[]} */
		this.setPoints = null;

		/** @type {EdtDynamicCheckVariableEditDto[]} */
		this.sequenceFinishedTags = null;

		/** @type {EdtDynamicCheckVariableEditDto[]} */
		this.variablesToMonitor = null;

		/** @type {EdtDynamicCheckVariableEditDto[]} */
		this.alarmVariables = null;
	}

	/**
	 * @typedef {Object} _EdtDynamicCheckEditDtoProps
	 * @property {string} hostName
	 * @property {string} serverName
	 * @property {string} modelName
	 * @property {number} log
	 * @property {number} readInterval
	 * @property {number} timeWindow
	 * @property {number} maxIterations
	 * @property {number} minSampleCountForVarianceCheck
	 * @property {string} sequenceStartItemId
	 * @property {EdtDynamicCheckVariableEditDto[]} disturbanceVariables
	 * @property {EdtDynamicCheckVariableEditDto[]} setPoints
	 * @property {EdtDynamicCheckVariableEditDto[]} sequenceFinishedTags
	 * @property {EdtDynamicCheckVariableEditDto[]} variablesToMonitor
	 * @property {EdtDynamicCheckVariableEditDto[]} alarmVariables
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _EdtDynamicCheckEditDtoProps} EdtDynamicCheckEditDtoProps
	 */
	/**
	 *
	 * @param {EdtDynamicCheckEditDtoProps} props
	 * @returns {EdtDynamicCheckEditDto}
	 */
	setup(props) {
		super.setup(props);

		this.hostName = props.hostName;
		this.serverName = props.serverName;
		this.modelName = props.modelName;
		this.log = props.log;
		this.readInterval = props.readInterval;
		this.timeWindow = props.timeWindow;
		this.maxIterations = props.maxIterations;
		this.minSampleCountForVarianceCheck = props.minSampleCountForVarianceCheck;
		this.sequenceStartItemId = props.sequenceStartItemId;
		this.disturbanceVariables = props.disturbanceVariables !== null ? props.disturbanceVariables.map(d => new EdtDynamicCheckVariableEditDto().setup(d)) : [];
		this.setPoints = props.setPoints !== null ? props.setPoints.map(d => new EdtDynamicCheckVariableEditDto().setup(d)) : [];
		this.sequenceFinishedTags = props.sequenceFinishedTags !== null ? props.sequenceFinishedTags.map(d => new EdtDynamicCheckVariableEditDto().setup(d)) : [];
		this.variablesToMonitor = props.variablesToMonitor !== null ? props.variablesToMonitor.map(d => new EdtDynamicCheckVariableEditDto().setup(d)) : [];
		this.alarmVariables = props.alarmVariables !== null ? props.alarmVariables.map(d => new EdtDynamicCheckVariableEditDto().setup(d)) : [];

		return this;
	}
}

export default EdtDynamicCheckEditDto;
